import React from 'react'
import InputShadow from './../../elements/InputShadow';
import ButtonShadow from './../../elements/ButtonShadow';

const SendPush = ({ values, _handleSendCollectifMessage, handleChange }) => {
    return (
        <div>
            <div className='my-3 text-center'>Envoyer un message</div>

            {/* INPUT TITLE */}
            <InputShadow name='title' value={values.title} onChange={handleChange} maxlength={40} placeholder='Titre' />
            <div style={{ textAlign:'center', color:'grey'}}>{values.title.length}/40</div>

            {/* INPUT MESSAGE */}
            <InputShadow name='message' value={values.message} onChange={handleChange} maxlength={140} placeholder='Message' />
            <div style={{ textAlign:'center', color:'grey'}}>{values.title.length}/140</div>

            {/* BUTTON SEND MESSAGE PUSH */}
            <ButtonShadow
                title='Envoyer'
                // onClick={_handleSendCollectifMessage}
                disabled={values.title && values.message ? false : true}
            />
        </div>
    )
}

export default SendPush
